/* eslint-disable max-len */

import { ICoinPageData } from '../types'

export const usdtPage: ICoinPageData = {
  title: 'coin_1022',
  description: 'coin_1023',
  // description:
  //   'Get a USDT loan with CoinRabbit in 3 minutes. Borrow against USDT for an unlimited term without credit checks. Receive up to 90% of your collateral in cash or crypto and continue holding. Get an instant loan now and pay whenever you want.',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'USDT (ETH)' }) }}
    />
  ),
  questionsBlock: {
    questions: [
      {
        title: 'coin_1024',
        answer: 'coin_1025',
      },
      {
        title: 'coin_1026',
        answer: 'coin_1027',
      },
      {
        title: 'coin_1028',
        answer: 'coin_1029',
      },
      {
        title: 'coin_1030',
        answer: 'coin_1031',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_1032',
        text: ['coin_1037'],
      },
      {
        title: 'coin_1033',
        text: ['coin_1038'],
      },
      {
        title: 'coin_1034',
        text: ['coin_1039', 'coin_1040', 'coin_1041', 'coin_1042'],
      },
      {
        title: 'coin_1035',
        text: ['coin_1043', 'coin_1044', 'coin_1045', 'coin_1046', 'coin_1047'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'USDT crypto review 1',
      },
      {
        link: 'https://coinrabbit.io/blog/coinrabbit-earnings-interest-review/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/integration-7CR_EARN1.png',
        imageAlt: 'USDT crypto review 2',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'USDT crypto review 3',
      },
    ],
  },
  videoId: 'PJRZb-8eJrQ',
  videoTitle: 'coin_1036',
}
